import type { FC } from 'react';

import {
  BalanceList,
  BalanceListSkeleton,
  UserBadges,
  UserBadgesSkeleton,
  UserInfo,
  UserInfoSkeleton,
  type BalanceListProps,
  type UserBadgesProps,
  type UserInfoProps,
} from '@wwe-portal/ui/features/user-profile';
import { EnergyCountDown } from '../../../features/offer/component/energy-countdown';

interface ProfileSectionProps {
  userInfo: UserInfoProps;
  userBadge: UserBadgesProps;
  balanceList: BalanceListProps;
  energyTime: string | undefined;
  onEndCountDown: () => void;
  isRefreshingEnergy?: boolean;
}

export const ProfileSection: FC<ProfileSectionProps> = ({
  userInfo,
  userBadge,
  balanceList,
  energyTime,
  onEndCountDown,
  isRefreshingEnergy = false,
}) => {
  return (
    <div className="flex flex-col gap-5">
      <UserInfo {...userInfo} />
      <UserBadges {...userBadge} />
      <BalanceList {...balanceList} />
      {!!energyTime && (
        <EnergyCountDown
          className="text-text600"
          endDate={energyTime}
          onEndCountDown={onEndCountDown}
        />
      )}
      {isRefreshingEnergy && (
        <div className="text-text600 flex items-center justify-center text-xs">
          <div className="mr-2 h-3 w-3 animate-spin rounded-full border-b-2 border-current"></div>
          Updating energy...
        </div>
      )}
    </div>
  );
};

export const ProfileSectionSkeleton = () => {
  return (
    <div className="flex flex-col gap-5">
      <UserInfoSkeleton />
      <UserBadgesSkeleton />
      <BalanceListSkeleton />
    </div>
  );
};
